import script from "./NewSupplierDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSupplierDrawer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__